import { i18n } from "@/plugin/i18n";

const CnpjHelpers = {
  checkCnpj: (rule, value, callback) => {
    if (!value) {
      return callback(new Error(i18n.tc("cnpj-obrigatorio")));
    }

    const valid = CnpjHelpers.validate(value);
    if (!valid) {
      return callback(new Error(i18n.tc("cnpj-invalido")));
    }
    callback();
  },
  charValue: function (char) {
    return char.charCodeAt(0) - 48;
  },
  validate: function (value) {
    const cnpj = String(value).replace(/[^0-9A-Za-z]/g, '').toUpperCase();

    if (cnpj == '') return false;
    if (cnpj.length != 14) return false;
    if (!/^[0-9A-Z]{12}[0-9]{2}$/.test(cnpj)) return false;
    if (cnpj == "00000000000000" ||
      cnpj == "11111111111111" ||
      cnpj == "22222222222222" ||
      cnpj == "33333333333333" ||
      cnpj == "44444444444444" ||
      cnpj == "55555555555555" ||
      cnpj == "66666666666666" ||
      cnpj == "77777777777777" ||
      cnpj == "88888888888888" ||
      cnpj == "99999999999999")
      return false;

    let tamanho = cnpj.length - 2
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += CnpjHelpers.charValue(numeros.charAt(tamanho - i)) * pos--;
      if (pos < 2)
        pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0))
      return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += CnpjHelpers.charValue(numeros.charAt(tamanho - i)) * pos--;
      if (pos < 2)
        pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1))
      return false;

    return true;
  },
};

export default CnpjHelpers;

export { CnpjHelpers };

